// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const PUT_CUSTOMER_NOTICE = 'v1/customerNotice/PUT_NOTICE';
export type PutCustomerNoticeSuccess = ApiSuccess<*, {notice: string}>;

export function putCustomerNotice(
  notice: string,
  journeyId: number,
  token: string
  // $FlowIgnore
) {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  return {
    types: ASYNC_TYPES(PUT_CUSTOMER_NOTICE),
    callAPI: () =>
      axios
        .put(
          `${cfg.bookingServiceUrl}/customer/notice/${journeyId}`,
          {notice},
          config
        )
        .then(() => ({}))
        .catch((error) => { throw error.response.data; }),
    notice,
  };
}
